import { render, staticRenderFns } from "./VehicleCatalog.vue?vue&type=template&id=7b97abd1&scoped=true"
import script from "./VehicleCatalog.vue?vue&type=script&lang=js"
export * from "./VehicleCatalog.vue?vue&type=script&lang=js"
import style0 from "./VehicleCatalog.vue?vue&type=style&index=0&id=7b97abd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b97abd1",
  null
  
)

export default component.exports